export const clearFee = ({commit}) => {
    commit('setFeePending', false);
    commit('setFeeComplete', false);

    commit('setFeeError', null);
    commit('setFee', {});
};
